module.exports = __webpack_public_path__ + "images/feature/20150603_01-feaf4d4081845b906de5c1b9cb1b1077.png";